import practice from "@/components/practice/Practice";
import practiceIndex from "@/components/practice/Index";
import practiceCreate from "@/components/practice/Create";
import practiceEdit from "@/components/practice/Edit";

export default {
  path: "/practices",
  component: practice,
  meta: {
    permission: "practice:read|practice:manage"
  },
  children: [
    {
      path: "list",
      name: "practice-list",
      component: practiceIndex,
      meta: {
        title: "Accounts",
        permission: "practice:read|practice:manage"
      }
    },
    {
      path: "new",
      name: "practice-create",
      component: practiceCreate,
      meta: {
        title: "Create a Practice",
        permission: "practice:read|practice:manage"
      }
    },
    {
      path: ":id/edit",
      name: "practice-edit",
      component: practiceEdit,
      props: true,
      meta: {
        title: "Edit a Practice",
        permission: "practice:update|practice:manage"
      }
    }
  ]
};
